import { render, staticRenderFns } from "./Publico.vue?vue&type=template&id=74a6b7fb&scoped=true"
import script from "./Publico.vue?vue&type=script&lang=js"
export * from "./Publico.vue?vue&type=script&lang=js"
import style0 from "./Publico.vue?vue&type=style&index=0&id=74a6b7fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a6b7fb",
  null
  
)

export default component.exports